import { DocumentNode } from '@apollo/client'
import { DeleteWorkSpaceDocument, DeleteWorkSpaceMutation } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import { WorkSpaceNode } from 'modules/space_control/hooks/useWorkSpaces'

type RefetchQueryDescriptor = {
  query: DocumentNode
  variables?: Record<string, unknown>
}

export const useDeleteWorkSpace = () => {
  const [executeMutation] = useMutation(DeleteWorkSpaceDocument, {
    extractorFn: (data: DeleteWorkSpaceMutation) =>
      data.spaceControlMutations.deleteSpacecontrolWorkSpace,
  })

  const deleteWorkSpace = async (
    workSpace: WorkSpaceNode,
    options?: { refetchQueries?: RefetchQueryDescriptor[] }
  ) => {
    if (!workSpace.id) {
      throw new Error('WorkSpace must have valid id, workArea and location')
    }

    return executeMutation({
      variables: {
        id: workSpace.id,
      },
      refetchQueries: options?.refetchQueries || [],
      awaitRefetchQueries: !!options?.refetchQueries?.length,
    })
  }

  return {
    deleteWorkSpace,
  }
}
